import {noop} from 'lodash';
import React, {FC, PropsWithChildren} from 'react';
import styled, {css} from 'styled-components';

import {HandlerOf, Renderer} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {Toggle} from '../../../../../libs/shared/ui/src/components/booleanInputs/toggle';
import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {StyledCellChildrenWrapperDiv} from './childrenCell';
import {TableCell, TableCellProps} from './tableCell';

/*
 * Props.
 */

export interface ToggleCellProps extends TableCellProps<boolean> {
  onChange: HandlerOf<boolean>;
  isDisabled?: boolean;
  renderToolip?: Renderer;
}

/*
 * Styles.
 */

const StyledToggleContainerDiv = styled.div<{$isDisabled: boolean}>`
  padding: 0 12px;

  ${(p) =>
    p.$isDisabled &&
    css`
      opacity: 0.4;
      pointer-events: none;
    `}
`;

/*
 * Component.
 */

export const ToggleCell: FC<PropsWithChildren<ToggleCellProps>> = ({
  onChange,
  isDisabled,
  renderToolip,
  ...cellProps
}) => (
  <TableCell
    {...cellProps}
    renderCell={(value) => (
      <StyledCellChildrenWrapperDiv
        $settings={cellProps.settings}
        $isHovering={Boolean(cellProps.isHovering)}
        $index={cellProps.index}
        $isSelected={Boolean(cellProps.isSelected)}
        $shouldRemoveTopBorderRadius={cellProps.shouldRemoveTopBorderRadius}
        $shouldRemoveBottomBorderRadius={cellProps.shouldRemoveBottomBorderRadius}
        $shouldRemoveLeftBorderRadius={cellProps.shouldRemoveLeftBorderRadius}
      >
        <StyledToggleContainerDiv
          onClick={(event) => {
            if (cellProps.isSelected) {
              return;
            }

            event.preventDefault();
            onChange(!value);
          }}
          $isDisabled={Boolean(isDisabled || cellProps.isSelected)}
        >
          <TooltipCoordinator persistent render={renderToolip} placement="top">
            <Toggle size={VisualSizesEnum.SMALL} isChecked={value} onChange={noop} />
          </TooltipCoordinator>
        </StyledToggleContainerDiv>
      </StyledCellChildrenWrapperDiv>
    )}
  />
);
